import React from "react";
import { Parallax } from "react-parallax";
import Face2 from "../../../assets/goldenback.jpg";

const BackgroundImageFace2 = () => {
  return (
    <Parallax bgImage={Face2} strength={600}>
      <div style={{ height: "50vh" }}></div>
      <a href="/bid"> </a>
    </Parallax>
  );
};

export default BackgroundImageFace2;
